<div class="stand-by-wrapper">
  <div class="stand-by">
    <peca-logotype color="dark" />
  </div>
</div>
